import { FooterMCAByStepName } from "@src/Footer/MCA/FooterMCAByStepName";
import { StepName } from "@src/Steps/Steps";
import { MouseEvent } from "react";

type FooterLegalMCAProps = {
  stepName: StepName;
};

export function ProtectionDonneesMCA() {
  const openMailTo = (e: MouseEvent) => {
    window.open("mailto:dpo@mc-alsace.fr", "mail");
    e.preventDefault();
  };

  return (
    <p>
      <small>
        Le contrat sâge autonomie vous est proposé par la Mutuelle
        Complémentaire d&apos;Alsace (MCA), mutuelle soumise aux dispositions du
        livre II du Code de la mutualité, agissant en qualité de distributeur de
        Tutélaire, dont le siège social est situé 6 route de Rouffach - CS 40062
        – 68027 Colmar Cedex et immatriculée sous le numéro Siren 778 900 027.
        <br />
        <br />
        <span style={{ textDecoration: "underline" }}>
          Données personnelles :
        </span>{" "}
        Vous disposez des droits d&apos;accès, de rectification,
        d&apos;opposition, de portabilité, d&apos;effacement et de limitation du
        traitement vous concernant.
        Pour les exercer, adressez un courrier simple au responsable de traitement par courrier à l’adresse postale suivante :
        DPO - Mutuelle Complémentaire d’Alsace, 6 route de Rouffach – CS 40062, 68027 COLMAR CEDEX, ou par mail :{" "}
        <a
          href="mailto:dpo@mc-alsace.fr"
          target="_blank"
          rel="noreferrer"
          onClick={openMailTo}
        >
          dpo@mc-alsace.fr
        </a>
        .
        <br />
        Pour plus d&apos;informations relatives à la gestion de vos données,
        vous pouvez à tout moment consulter notre politique de confidentialité sur le site internet{' '}
        <a
          href="https://www.mc-alsace.fr/"
          target="_blank"
          rel="noreferrer"
        >
          www.mc-alsace.fr
        </a>{" "}
        ou la demander par courrier simple au responsable de traitement de la Mutuelle Complémentaire d’Alsace,
        mutuelle soumise aux dispositions du livre II du Code de la Mutualité,
        dont le siège social est situé 6 route de Rouffach CS 40062 - 68027 Colmar Cedex et immatriculée au répertoire SIRENE sous le N° SIREN 778 900 027.
      </small>
    </p>
  );
}

export function FooterLegalMCA({ stepName }: FooterLegalMCAProps) {
  return (
    <>
      <div className="footer-legal__part">
        <FooterMCAByStepName stepName={stepName} />
      </div>
      <div className="footer-legal__part">
        <div className="footer-legal__logos">
          <img
            className="footer-legal__logo-tutelaire"
            alt="logo tutelaire"
            src="/logo-tutelaire.png"
          />
          <img
            className="footer-legal__logo-mutualite"
            alt="logo mutualité francaise"
            src="/logo-mutualite-francaise.png"
          />
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.tutelaire.fr/mentions-legales-cookies"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Tutélaire
          </a>
        </div>
        <div className="stepper__mentions-legales">
          <a
            href="https://www.mc-alsace.fr/conditions-generales-utilisation-mentions-legales"
            target="_blank"
            rel="noreferrer"
          >
            Mentions légales Mutuelle Complémentaire d'Alsace
          </a>
        </div>
      </div>
    </>
  );
}
